const mistakes = [
  {
    icon: "ri-file-damage-line",
    title: "Wrong Photo Size or Quality",
    description: "Passport photos must be 2x2 inches with a white background and taken within the last 6 months. Most Juneau pharmacies and post offices offer photo services.",
  },
  {
    icon: "ri-ship-line",
    title: "Not Accounting for Juneau's Isolation",
    description: "Juneau has no road connection to the lower 48. All shipping is by air, which adds transit time in both directions. Plan at least 3 weeks before travel.",
  },
  {
    icon: "ri-user-unfollow-line",
    title: "Forgetting Both Parents for Child Applications",
    description: "Child passports under 16 require both parents or legal guardians present at the acceptance facility — or a notarized consent form if one parent can't attend.",
  },
  {
    icon: "ri-time-line",
    title: "Applying Too Late Before Travel",
    description: "Even expedited processing takes 2–9 days plus air shipping time. Juneau residents should apply at least 3 weeks before travel to safely account for Alaska logistics.",
  },
  {
    icon: "ri-draft-line",
    title: "Not Checking Passport Expiration Rules",
    description: "Many countries require 6 months of passport validity beyond your travel dates. Always verify the entry requirements for your specific destination.",
  },
  {
    icon: "ri-ship-2-line",
    title: "Missing Alaska Cruise Passport Deadlines",
    description: "Many Juneau visitors are cruise passengers — but Alaska residents departing by cruise need valid passports too. Don't wait until cruise season to apply.",
  },
];

export default function MistakesSection() {
  return (
    <section id="mistakes" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            6 Passport Mistakes Juneau Applicants Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Avoid these common pitfalls that delay Juneau passport applications — several of which are unique to Southeast Alaska&apos;s geography.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 mb-4">
                <i className={`${m.icon} text-red-500 text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}